export default "__VITE_ASSET__a1f7ee5e__"